import React, { useEffect, useState } from "react";
import * as core from "@material-ui/core";
import { useTranslation } from "react-i18next";

const PaymentInformation = (props) => {
    const { touched, errors, values, handleBlur, handleChange, setFieldValue, } = props;
    const { t } = useTranslation();
    
    return (
        <core.Card>
            <core.CardHeader title={t("pages.WorkerDemanderProfile.PaymentInformation.stepname")} />
            <core.Divider />
            
            <core.CardContent>                
                <core.Grid container spacing={2}>
                    <core.Grid item md={6} xs={12}>
                        <core.TextField fullWidth
                                        InputLabelProps={{shrink: true,}}
                                        label={t("workerDemander.currentAccountCardCode")}
                                        name="currentAccountCardCode"
                                        error={Boolean(touched.currentAccountCardCode && errors.currentAccountCardCode)}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.currentAccountCardCode} />
                    </core.Grid>
                    
                    <core.Grid item md={6} xs={12}>
                        <core.TextField fullWidth
                                        InputLabelProps={{shrink: true,}}
                                        label={t("workerDemander.currentAccountCardCodeDescription")}
                                        name="currentAccountCardCodeDescription"
                                        error={Boolean(touched.currentAccountCardCodeDescription && errors.currentAccountCardCodeDescription)}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.currentAccountCardCodeDescription} />
                    </core.Grid>
                    
                    <core.Grid item md={6} xs={12}>
                        <core.TextField fullWidth
                                        InputLabelProps={{shrink: true,}}
                                        label={t("workerDemander.paymentMethodCode")}
                                        name="paymentMethodCode"
                                        error={Boolean(touched.paymentMethodCode && errors.paymentMethodCode)}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.paymentMethodCode} />
                    </core.Grid>
                    
                    <core.Grid item md={6} xs={12}>
                        <core.TextField fullWidth
                                        InputLabelProps={{shrink: true,}}
                                        label={t("workerDemander.taxNumber")}
                                        name="taxNumber"
                                        error={Boolean(touched.taxNumber && errors.taxNumber)}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.taxNumber} />
                    </core.Grid>
                    
                    <core.Grid item md={6} xs={12}>
                        <core.TextField fullWidth
                                        InputLabelProps={{shrink: true,}}
                                        label={t("workerDemander.registrationNumber")}
                                        name="registrationNumber"
                                        error={Boolean(touched.registrationNumber && errors.registrationNumber)}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.registrationNumber} />
                    </core.Grid>
                    
                    <core.Grid item md={6} xs={12}>
                        <core.TextField fullWidth
                                        InputLabelProps={{shrink: true,}}
                                        label={t("workerDemander.debtorNumber")}
                                        name="debtorNumber"
                                        error={Boolean(touched.debtorNumber && errors.debtorNumber)}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.debtorNumber} />
                    </core.Grid>
                    
                    <core.Grid item md={6} xs={12}>
                        <core.TextField fullWidth
                                        InputLabelProps={{shrink: true,}}
                                        label={t("workerDemander.chamberOfCommerceNumber")}
                                        name="chamberOfCommerceNumber"
                                        error={Boolean(touched.chamberOfCommerceNumber && errors.chamberOfCommerceNumber)}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.chamberOfCommerceNumber} />
                    </core.Grid>
                </core.Grid>
            </core.CardContent>
            
            {/* Master state
            <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
        </core.Card>
    );
};

export default PaymentInformation;
